<template>
  <div>
    <ul class="airpositionDataSourceUl">
      <li
        @click.stop="switchI('通航飞机')"
        :class="
          Air.General === true
            ? 'link featureControl featureactive'
            : 'link featureControl '
        "
      >
        通航飞机
      </li>
      <li
        @click.stop="switchI('运输飞机')"
        :class="
          Air.Transport === true
            ? 'link featureControl featureactive'
            : 'link featureControl'
        "
      >
        运输飞机
      </li>
      <li
        @click.stop="switchI('无人机')"
        :class="
          Air.UAV === true
            ? 'link featureControl featureactive'
            : 'link featureControl '
        "
      >
        无人机
      </li>
      <li
        @click.stop="switchI('轻型终端')"
        :class="
          Air.Terminal === true
            ? 'link featureControl featureactive'
            : 'link featureControl'
        "
      >
        轻型终端
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  props:['Air'],
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapMutations({
      changeWatchAir: "swichLayer/changeWatchAir",
    }),
    switchI(item) {
      switch (item) {
        case "通航飞机":
          if (!this.Air.General) {
            this.Air.General = true;
          } else {
            this.Air.General = false;
          }
          break;
        case "运输飞机":
          if (!this.Air.Transport) {
            this.Air.Transport = true;
          } else {
            this.Air.Transport = false;
          }
          break;
        case "无人机":
          if (!this.Air.UAV) {
            this.Air.UAV = true;
          } else {
            this.Air.UAV = false;
          }
          break;
        case "轻型终端":
          if (!this.Air.Terminal) {
            this.Air.Terminal = true;
          } else {
            this.Air.Terminal = false;
          }
          break;
        default:
          break;
      }

      //初始化设置飞机分类

      this.changeWatchAir(this.Air);
   
    },
  },
};
</script>

<style lang="less" scoped>
.featureControl {
}

.featureactive {
  color: #2cfdff !important;
}

.link {
  cursor: pointer;
  display: block;
  // padding: 8px 15px 5px 35px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  color: #c3d3ea;
  font-size: 12px;
  position: relative;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

// .link:hover {
//   color: #2cfdff;
// }

.airpositionDataSourceUl li {
  height: 29px;
  padding-left: 10px;
}
</style>